import {TemplateAsset} from 'common/src/modules/dynamicParameters/dynamicParameters.types';
import {setTemplateAssets} from '../movieAssets.slice';
import {CLDispatch, RootState} from 'common/src/redux/store';

type TemplateAssetsUpdater =
  | TemplateAsset[]
  | ((currentAssets: TemplateAsset[]) => TemplateAsset[]);

export default function updateTemplateAssets(updateAssets: TemplateAssetsUpdater) {
  return async (dispatch: CLDispatch, getState: () => RootState) => {
    const state = getState();
    const currentAssets = state.creativeTemplatePage.movieAssets.templateAssets;
    const assets = typeof updateAssets === 'function' ? updateAssets(currentAssets) : updateAssets;

    dispatch(setTemplateAssets(assets));
  };
}
